var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkbox-filter-component" }, [
    _vm.hasSearch
      ? _c("div", { staticClass: "search-area" }, [
          _c("div", { staticClass: "search-container" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.search,
                  expression: "search",
                },
              ],
              staticClass: "search-field",
              attrs: { placeholder: _vm.searchPlaceholder },
              domProps: { value: _vm.search },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.search = $event.target.value
                  },
                  _vm.searchValue,
                ],
              },
            }),
            !_vm.search
              ? _c("img", {
                  staticClass: "search-icon",
                  attrs: {
                    src: "assets/images/search.svg",
                    width: "16",
                    height: "16",
                  },
                })
              : _vm._e(),
            _vm.search
              ? _c("span", {
                  staticClass: "clear-icon",
                  on: { click: _vm.clearSearch },
                })
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "infinite-scroll",
            rawName: "v-infinite-scroll",
            value: _vm.loadMoreData,
            expression: "loadMoreData",
          },
        ],
        ref: "scrollList",
        staticClass: "checkbox-list",
      },
      [
        _vm._l(_vm.options, function (option) {
          return _c(
            "div",
            { key: option.id, staticClass: "checkbox-item" },
            [
              _c(
                "checkbox",
                {
                  attrs: { value: _vm.isChecked(option) },
                  on: {
                    input: function ($event) {
                      return _vm.toggleOption(option)
                    },
                  },
                },
                [_vm._v(_vm._s(option.displayName || option.name))]
              ),
            ],
            1
          )
        }),
        !_vm.isLoading && _vm.options.length === 0
          ? _c("div", { staticClass: "empty-state" }, [
              _vm._v("No options found"),
            ])
          : _vm._e(),
        _vm.isLoadingMore
          ? _c("div", { ref: "load", staticClass: "load-more-indicator" }, [
              _vm._m(0),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "small-loader" }, [
      _c("div", { staticClass: "loader-dot" }),
      _c("div", { staticClass: "loader-dot" }),
      _c("div", { staticClass: "loader-dot" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }